export { default as ReceivingManualList } from './manual/ReceivingManualList';
export { default as ReceivingAutomatedList } from './automated/ReceivingAutomatedList';
export { default as ReceivingEdit } from './ReceivingEdit';
export { default as ReceivingDetail } from './ReceivingDetail';
export { default as ReceivingExpandList } from './ReceivingExpandList';



// WEBPACK FOOTER //
// ./src/modules/receiving/pages/index.js